import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { goToCheckoutSection } from '../lib/config';
type CtaButtonProps = {
  label?: string;
  subLabel?: string;
  className?: string;
};
export function CtaButton({
  label = 'Quiero ordenar mi consultorio',
  subLabel,
  className = ''
}: CtaButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-67" data-mp="cjr8bxn0jvr7">
      <button type="button" onClick={goToCheckoutSection} className="group w-full rounded-2xl bg-teal-500 px-5 py-4 text-center text-base font-extrabold uppercase tracking-wide text-[#062331] shadow-lg shadow-teal-500/30 transition active:scale-[0.98] hover:bg-teal-400 focus:outline-none focus-visible:ring-4 focus-visible:ring-teal-300" data-id="element-68" data-mp="cn5e7fuvyn3e">
        <span className="inline-flex items-center justify-center gap-2" data-id="element-69" data-mp="vbsgjqlogyda">
          {label}
          <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-70" data-mp="19busyxb7uzl5" />
        </span>
      </button>
      {subLabel ? <p className="mt-2 text-center text-xs font-medium text-teal-100/70" data-id="element-71" data-mp="35x5xfh3h2u3j">
          {subLabel}
        </p> : null}
    </div>;
}